export const TASK_ATTACHMENT_ACCEPT =
  '.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.zip,.png,.jpg,.jpeg,.gif,.webp,.svg,.bmp,.mp4,.webm,.mov,.m4v,.mkv,.avi,.mp3,.wav,.ogg,.m4a,.aac,.flac,.opus';

const PLAN_DEFAULT_MAX_BYTES: Record<string, number> = {
  SOLO: 50 * 1024 * 1024,
  TEAM: 150 * 1024 * 1024,
  SCALE: 150 * 1024 * 1024,
  ENTERPRISE: 150 * 1024 * 1024,
};

export function getMaxAttachmentBytesForPlan(plan?: string, limits?: { maxAttachmentFileBytes?: number }): number {
  if (limits?.maxAttachmentFileBytes != null) return limits.maxAttachmentFileBytes;
  const key = String(plan || 'SOLO').toUpperCase();
  return PLAN_DEFAULT_MAX_BYTES[key] ?? PLAN_DEFAULT_MAX_BYTES.SOLO;
}

export function formatAttachmentMaxLabel(bytes: number): string {
  const mb = bytes / (1024 * 1024);
  if (mb >= 10) return `${Math.round(mb)} MB`;
  return `${mb.toFixed(1)} MB`;
}

/** Consistent marketing copy — Starter 50 MB, Growth+ 150 MB per file. */
export const ATTACHMENT_PLAN_FEATURE_KEY = 'attachments.planFeature';
